<template>
  <Teleport to="body">
    <Transition name="overlay">
      <div v-if="visible" class="fixed inset-0 z-[800] flex items-center justify-center p-4">
        <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" />
        <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 animate-fade-in">
          <div class="flex flex-col items-center text-center mb-4">
            <div class="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center mb-3">
              <svg class="w-6 h-6 text-amber-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900">Still there?</h3>
            <p class="text-sm text-gray-500 mt-1">
              You've been idle for a while. Your session will end in
              <span class="font-data font-medium text-gray-900">{{ countdown }}s</span>.
            </p>
          </div>

          <div class="flex gap-3">
            <button @click="logout" class="btn-secondary flex-1">Log out</button>
            <button @click="keepWorking" class="btn-primary flex-1">Keep working</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import session from '../services/session.js'

const COUNTDOWN_SECONDS = 30

export default {
  name: 'IdleWarningModal',
  data() {
    return {
      visible: false,
      countdown: COUNTDOWN_SECONDS,
      timer: null,
      unsubscribe: null
    }
  },
  mounted() {
    this.unsubscribe = session.on((event) => {
      if (event === 'idle-warning') this.open()
      else if (event === 'logout') this.close()
    })
  },
  beforeUnmount() {
    if (this.unsubscribe) this.unsubscribe()
    this.stopTimer()
  },
  methods: {
    open() {
      this.countdown = COUNTDOWN_SECONDS
      this.visible = true
      this.stopTimer()
      this.timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) this.logout()
      }, 1000)
    },
    close() {
      this.visible = false
      this.stopTimer()
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    async keepWorking() {
      this.close()
      await session.continueSession()
    },
    logout() {
      this.close()
      session.forceLogout('idle')
    }
  }
}
</script>
